export default "__VITE_ASSET__b76e0bf4__"